import "./components/sidebar";
import "./components/mobileHeader";
import "./components/reportQuarterAjax";
import "./components/reportingAjax";
import "./components/misc.js";

jQuery(document).ready(function ($) {
	if ($(".resource-upload-submit").length) {
		var resourceSubmit = $(".resource-upload-submit button");
		var fileInput = $('.resource-upload input[type="file"]');
		const linkShareField = document.querySelector(".link-share input");

		const resourceType = document.querySelector(".resource-type-selection");

		if (resourceType) {
			resourceType.addEventListener("change", (e) => {
				if (e.target.checked && e.target.value === "isLink") {
					linkShareField?.setAttribute("aria-required", true);
				} else {
					linkShareField?.setAttribute("aria-required", false);
				}
			});
		}

		if (linkShareField) {
			linkShareField.addEventListener("keyup", (e) => {
				if (e.target.value) resourceSubmit.prop("disabled", false);
				else resourceSubmit.prop("disabled", true);
			});
		}

		resourceSubmit.prop("disabled", true).prop("title", "Please wait -- your file is uploading");

		// Check file input for changes
		fileInput.on("change input", function () {
			// Check if a file is selected
			if (this.files.length > 0) {
				resourceSubmit.prop("disabled", false); // Enable button if file is selected
			} else {
				resourceSubmit.prop("disabled", true); // Disable button if no file is selected
			}
		});
	}

	// Forms
	$(".frm_radio input").click(function () {
		if ($(this).is(":checked")) {
			if ($(this).closest(".frm_opt_container").find("label.checked").length) {
				$(this).closest(".frm_opt_container").find("label.checked").removeClass("checked");
			}
			$(this).closest("label").addClass("checked");
		}
	});

	// Goal Trackers
	if ($(".progress-bar").length) {
		var progress;
		$(".progress-bar").each(function () {
			progress = $(this).attr("data-progress");

			$(this)
				.find(".pb-inner")
				.css("width", progress * 10 + "%");
		});
	}

	// Learning Plan Area
	if ($(".previous-entries").length) {
		if ($(".previous-entries").find(".frm_no_entries").length <= 0) {
			// there's at least one previous entry so show this section that's hidden by default
			$(".previous-entries").addClass("show");
		}
	}

	$(".add-lp").click(function (e) {
		e.preventDefault();

		$(this).closest(".et_pb_button_module_wrapper").hide();

		$(".lp-form-display .frm_forms").addClass("show");

		return false;
	});

	// remove row functionality
	$("body").on("click", ".toggle-header i", function (e) {
		$(this).closest(".frm_repeat_sec").find(".frm_remove_form_row").trigger("click");
	});

	// Add Goal (add/remove page and LP form page)
	$("body").on("click", "a.add-goal, .frm_add_form_row", function (e) {
		if ($(this).hasClass("add-goal")) {
			e.preventDefault();
			$(this).parent("p").prev(".toggle-item").find(".frm_add_form_row").trigger("click");

			var addTrashIcon = setInterval(function () {
				// Replace this condition with your own
				if ($(".frm_form_field > select").length == 0) {
					clearInterval(addTrashIcon); // Stop the interval
					// Execute your logic here
					var addViewStyles = setInterval(function () {}, 500);
				} else {
					$(".frm_form_field > select").each(function () {
						$(this).wrap('<div class="select-wrapper" />');
						if (typeof $(this).attr("multiple") !== "undefined" && $(this).attr("multiple") !== false) {
							$(this).closest(".select-wrapper").addClass("multiple");
						}
					});
					// console.log('Condition not met yet.');
				}
			}, 500);

			if ($(".frm_remove_form_row").length) {
				$(".frm_remove_form_row").each(function () {
					if ($(this).find("i").length) {
						return;
					} else {
						$('<i class="fa-solid fa-trash"></i>').insertInto($(this));
					}
				});
			}
			return false;
		}

		// style new select fields
		var triggerEditMode = setInterval(function () {
			// Replace this condition with your own
			if ($(".frm_form_field > select").length == 0) {
				clearInterval(triggerEditMode); // Stop the interval
				// Execute your logic here
				var addViewStyles = setInterval(function () {}, 500);
			} else {
				$(".frm_form_field > select").each(function () {
					$(this).wrap('<div class="select-wrapper" />');
					if (typeof $(this).attr("multiple") !== "undefined" && $(this).attr("multiple") !== false) {
						$(this).closest(".select-wrapper").addClass("multiple");
					}
				});
				// console.log('Condition not met yet.');
			}
		}, 500);
	});

	// Add Toggles to Goals add / remove Page
	if ($(".view-add-lp").length) {
		// Use a timeout to delay the click trigger, but trigger click on edit links on Goals Add/Remove page to display all form submission data to allow frontend editing
		if ($(".frm_edit_link").length) {
			var triggerEditMode = setInterval(function () {
				// Replace this condition with your own
				var conditionMet = $(".frm_edit_link:not(.triggered)").length <= 0; // Example condition
				if (conditionMet) {
					// console.log('Condition met! Stopping interval.');
					clearInterval(triggerEditMode); // Stop the interval

					$(".frm_form_field > select").each(function () {
						$(this).wrap('<div class="select-wrapper" />');
						if (typeof $(this).attr("multiple") !== "undefined" && $(this).attr("multiple") !== false) {
							$(this).closest(".select-wrapper").addClass("multiple");
						}

						if ($(this).attr("name") == "item_meta[190]" && $("span.pg-name").length) {
							var formEntryID = $(this).closest("[id^=frm_container_").attr("id");
							var infoTarget = $('.active-lp-count a[href="#' + formEntryID + '"]');

							if (infoTarget) {
								$('<option selected="selected">' + infoTarget.find("span.pg-name").text() + "</option>").appendTo($(this));
							}
						}
					});
				} else {
					$(".frm_edit_link").each(function () {
						$(this).addClass("triggered").trigger("click"); // Trigger a click on each edit link
					});
					// console.log('Condition not met yet.');
				}
			}, 500);
		}

		var addToggles = setInterval(function () {
			// Replace this condition with your own
			var conditionMet = $(".toggle-item").length >= 1 && $(".toggle-item:not(.styled)").length <= 0; // Example condition
			if (conditionMet) {
				// console.log('Condition met! Stopping interval.');
				clearInterval(addToggles); // Stop the interval
			} else {
				// console.log('Condition not met yet.');

				// add Toggle display to Learning Plan listing
				$(".toggle-item:not(.styled").each(function (e) {
					if ($(this).find(".frm_fields_container").length > 0) {
						// var lpPG = $(this).find('#frm_field_190_container option:selected').val();
						if ($("span.pg-name").length) {
							var formEntryID = $(this).closest("[id^=frm_container_").attr("id");
							var infoTarget = $('.active-lp-count a[href="#' + formEntryID + '"]');

							if (infoTarget) {
								var lpPG = infoTarget.find("span.pg-name").text();
							}
						}

						var lpStatus = $(this).find(".lp-current-status input:checked").val();
						var lpStatusIcon = lpStatus.toLowerCase();
						$(this)
							.find(".toggle-header")
							.html('<h2><span class="th">' + $(this).find(".toggle-header").text() + ' <span class="th-pg">Peer Guide: ' + lpPG + '</span></span><span class="th-lps lps-' + lpStatusIcon + '">Status: ' + lpStatus + "</span></h2>");
						$('<div class="toggle-content" />').insertAfter($(this).find("#frm_field_189_container"));
						$(this).children().wrapAll('<div class="toggle-content" />');
						$(this).find("[id^=frm_field_189]").insertBefore($(this).find(".toggle-content"));

						if (lpStatusIcon === "complete") {
							$(this).find(".frm_inplace_edit.frm_edit_link").remove();
							$(this).find(".frm_edit_link_container + p .ocfp-default-btn").remove();
						}
						$(this).addClass("styled");
					}
				});
			}
		}, 500);
	}

	// Add Toggles to Goals add / remove Page
	if ($(".lp-form-view").length) {
		// Use a timeout to delay the click trigger, but trigger click on edit links on Goals Add/Remove page to display all form submission data to allow frontend editing
		if ($(".frm_edit_link").length) {
			var triggerEditMode = setInterval(function () {
				// Replace this condition with your own
				var conditionMet = $(".frm_edit_link:not(.triggered)").length <= 0; // Example condition
				if (conditionMet) {
					// console.log('Condition met! Stopping interval.');
					clearInterval(triggerEditMode); // Stop the interval
					// Execute your logic here
					var addViewStyles = setInterval(function () {
						// Replace this condition with your own
						var conditionMet = $(".frm_repeat_sec:not(.styled)").length <= 0; // Example condition
						if ($(".frm_repeat_sec").length > 0 && $(".frm_repeat_sec:not(.styled)").length <= 0) {
							if ($(".submit-all").length) {
								$(".submit-all").fadeIn().addClass("show");
							}
							if ($(".add-goal").length) {
								$(".add-goal").fadeIn().addClass("show");
							}
							clearInterval(addViewStyles); // Stop the interval
							// Execute your logic here
						} else {
							// console.log('Condition not met yet.');
							$(".frm_repeat_sec:not(.styled)").each(function () {
								$(this).find(".frm_html_container").addClass("toggle-header");
								$(this).children().wrapAll('<div class="toggle-content" />');
								$(this).find("[id^=frm_field_194]").insertBefore($(this).find(".toggle-content"));
								$(this).addClass("styled");
							});
						}
					}, 500);
				} else {
					$(".frm_edit_link").each(function () {
						$(this).addClass("triggered").trigger("click"); // Trigger a click on each edit link
					});
					// console.log('Condition not met yet.');
				}
			}, 500);
		}
	}

	// Open / Close View Toggle (Goals: Add/Remove)
	$("body").on("click", ".toggle-header", function (e) {
		e.preventDefault();

		if ($(this).find("h3 > i").length <= 0) {
			$('<i class="fa-solid fa-trash"></i>').appendTo($(this).find("h3"));
		}

		if ($(this).hasClass("open")) {
			$(this).removeClass("open");
		} else {
			$(this).addClass("open");
		}

		return false;
	});

	// Save Goals (add/remove page)
	$(".submit-all a").click(function (e) {
		e.preventDefault();

		$(".frm_button_submit").each(function () {
			$(this).trigger("click");
		});

		return false;
	});

	// Select custom design
	if ($(".frm_form_field select").length) {
		$(".frm_form_field select").each(function () {
			$(this).wrap('<div class="select-wrapper" />');
			if (typeof $(this).attr("multiple") !== "undefined" && $(this).attr("multiple") !== false) {
				$(this).closest(".select-wrapper").addClass("multiple");
			}
		});
	}

	// PEER GUIDES
	if (($("body").hasClass("pl-reports-view") && $(".frm_no_entries").length) || ($("body").hasClass("pl-reports-view") && $(".reports-list-title:not(.smaller)").length <= 0)) {
		$("body").removeClass("pl-reports-view");
	}

	// using Peer Guide learner filters
	$("body").on("change", ".report-selects select", function () {
		if ($(".select-quarter").length) {
			// quarter and learner must be selected to continue
			if ($(".select-learner select option:selected").val() !== "" && $(".select-quarter select option:selected").val() !== "") {
				var encodedQuarter = encodeURIComponent($(".select-quarter option:selected").val());
				encodedQuarter = encodedQuarter.replace(/\(/g, "%28").replace(/\)/g, "%29");
				// console.log(encodedQuarter);
				$(".pg-view-learner").attr("href", $("#pick-learner option:selected").val() + "&quarter=" + encodedQuarter);

				$(".pg-view-learner").removeClass("disabled");
			} else {
				$(".pg-view-learner").addClass("disabled");
			}
		} else {
			// only learner needs to be selected
			if ($(".select-learner select option:selected").val() !== "") {
				$(".pg-view-learner").removeClass("disabled");
			} else {
				$(".pg-view-learner").addClass("disabled");
			}
		}
	});

	// View learner reports list
	$(".pg-view-learner").click(function (e) {
		e.preventDefault();

		if ($(".triggers").length) {
			window.location.href = $(".triggers a").attr("href");
		} else {
			if ($(".select-quarter").length) {
				// we've built a URL, so let's go to that
				window.location.href = $(".pg-view-learner").attr("href");
			} else {
				// go to the Peer Learner's list view
				if ($("#pick-learner option:selected").val() !== "") {
					window.location.href = $("#pick-learner option:selected").val();
				}
			}
		}

		return false;
	});

	// $(window).on("load", function () {
	// 	// Populate Quarterly Review form with previously entered data
	// 	if ($(".hidden-data").length) {
	// 		if ($(".qr-select-lp").length) {
	// 			var lpCount = $(".hidden-data").length;
	// 			// console.log(lpCount);
	// 			for (var i = 1; i <= lpCount; i++) {
	// 				var entryID = $(".hidden-data")
	// 					.eq(i - 1)
	// 					.find(".lp-entry-id")
	// 					.text();
	// 				// check if the body has a class of pl-submitted-#, if it does, a report for this LP has been submitted this quarter so exclude it from the options
	// 				if ($("body").hasClass("pl-submitted-" + entryID)) {
	// 					continue;
	// 				} else {
	// 					var peerGuide = $(".hidden-data")
	// 						.eq(i - 1)
	// 						.find(".get-pg")
	// 						.text();
	// 					$('<option data-lp="' + entryID + '" value="' + entryID + '">Learning Plan with Peer Guide ' + peerGuide + "</option>").appendTo($(".qr-select-lp select"));
	// 				}
	// 			}

	// 			$(".frm_button_submit").css("display", "none");
	// 		}
	// 	}

	// 	$(".qr-select-lp select").on("change", function () {
	// 		if ($(this).val() !== "") {
	// 			// hide the select after a selection is made
	// 			$(this).closest(".frm_form_field").hide(500);
	// 			$(".frm_button_submit").css("display", "block");
	// 		}

	// 		var selectedLP = $(this).find("option:selected").attr("data-lp");

	// 		// 1. Peer Guide
	// 		$("#frm_field_214_container input")
	// 			.removeAttr("readonly")
	// 			.val(
	// 				$("#lpe-" + selectedLP)
	// 					.find(".get-pg")
	// 					.text()
	// 			)
	// 			.attr("readonly", "readonly");

	// 		// 2. Length of Support
	// 		$(
	// 			'#frm_field_218_container select option[value="' +
	// 				$("#lpe-" + selectedLP)
	// 					.find(".get-support")
	// 					.text() +
	// 				'"]'
	// 		).attr("selected", "selected");

	// 		// 3. Previous Entered Goals
	// 		var selectedLPGoals = $("#lpe-" + selectedLP).find(".goal").length;

	// 		if (selectedLPGoals > 0) {
	// 			var addRows = setInterval(function () {
	// 				// Replace this condition with your own
	// 				if ($(".frm_repeat_sec").length == selectedLPGoals) {
	// 					clearInterval(addRows); // Stop the interval
	// 					// Populate Quarterly Review form with previously entered goals
	// 					var count = 0;

	// 					$("#lpe-" + selectedLP)
	// 						.find(".goal")
	// 						.each(function () {
	// 							// Get values from the source divs
	// 							var goalID = $(this).find($(".goal-id")).text();
	// 							var goalTitle = $(this).find($(".goal-title")).text();
	// 							var goalTopic = $(this).find($(".goal-topic")).text();
	// 							var goalStatus = $(this).find($(".goal-status")).text();
	// 							var newRow = "frm_section_232-" + count;

	// 							// Populate the new row inputs with the values
	// 							$("#" + newRow)
	// 								.find("h3")
	// 								.html("Goal " + (count + 1) + ": <span>" + goalTitle + "</span>");
	// 							$("#" + newRow)
	// 								.find('input[name*="[251]"]')
	// 								.val(goalID); // Replace with your actual subfield key
	// 							$("#" + newRow)
	// 								.find('input[name*="[235]"]')
	// 								.val(goalTitle); // Replace with your actual subfield key
	// 							$("#" + newRow)
	// 								.find('input[name*="[355]"]')
	// 								.removeAttr("readonly")
	// 								.val(goalTopic)
	// 								.attr("readonly", "readonly"); // Replace with your actual subfield key

	// 							// if($('#' + newRow).find('select[name*="[236]"] option[value="' + goalTopic + '"]').length) {
	// 							// 	$('#' + newRow).find('select[name*="[236]"] option[value="' + goalTopic + '"]').attr('selected', 'selected').addClass('selected');

	// 							// 	var clickTopic = setInterval(function() {
	// 							// 		var $goal_topic = $('#' + newRow).find('select[name*="[236]"]');
	// 							// 		console.log(1);
	// 							// 		if ($goal_topic.length > 0) {
	// 							// 		console.log(2);
	// 							// 		  $goal_topic.find('option.selected').trigger('change');
	// 							// 		  clearInterval(clickTopic); // stop checking once it's set
	// 							// 		}
	// 							// 	}, 200); // check every 200ms
	// 							// }

	// 							count++;
	// 						});

	// 					$(".frm_repeat_sec:not(.styled)").each(function () {
	// 						$(this).find(".frm_html_container").addClass("toggle-header");
	// 						$(this).children().wrapAll('<div class="toggle-content" />');
	// 						$(this).find(".toggle-header").insertBefore($(this).find(".toggle-content"));
	// 						$(this).addClass("styled");
	// 					});
	// 				} else {
	// 					$(".frm_repeat_sec").find(".frm_add_form_row").click(); // Trigger the 'Add Row' button click
	// 				}
	// 			}, 500);

	// 			// also trigger quarter click because sometimes it's coming back as invalid for some reason
	// 			$(".select-quarter select").trigger("click");
	// 		}
	// 	});
	// });

	// PEER LEARNERS
	if ($(".list-only").length) {
		if (window.location.href.indexOf("/entry/") <= 0) {
			$(".list-only").each(function () {
				$(this).addClass("show");
			});
		}
	}

	if ($(".active-lp-count").length && $(".add-lp-count").length) {
		var activeLPs = $(".active-lp-count li").length;
		$(".add-lp-count .lp-count").text(activeLPs);
		if (activeLPs === 1) {
			$(".add-lp-count .plural").remove();
		}
	}

	// REPORTING
	// If someone changes goal status to 10 on reporting form, automatically set completed to Yes
	$("body").on("change", ".goal-progress select", function () {
		if ($(this).val() === "10") {
			if ($(this).closest(".toggle-content").find(".goal-status .frm_switch").attr("aria-checked") !== "true") {
				$(this).closest(".toggle-content").find(".goal-status input[type=checkbox]").trigger("click");
			}
		}
	});

	if ($(".reporting-hide").length) {
		if ($("body").hasClass("reporting-inactive")) {
			$(".reporting-hide.reporting-inactive").removeClass("reporting-hide");
		} else {
			$(".reporting-hide:not(.reporting-inactive)").removeClass("reporting-hide");
		}

		$(".reporting-hide").each(function () {
			$(this).remove();
		});
	}

	// Change Password email confirmation message display depending on logged in resetting password vs. logged out resetting password via reset link vs. logged in requesting reset email link
	let getURL = window.location.href;
	if ($("#frm_form_42_container").length && $("#frm_form_42_container .frm_message").length) {
		if (getURL.indexOf("key=") >= 0 || getURL.indexOf("login=") >= 0) {
			$("#frm_form_42_container").addClass("pw-success");
		} else {
			$("#frm_form_42_container").addClass("e-success");
		}
	}
});
